import constants from "../utils/constants";

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function JsonTryParse(str) {
  try {
    if (typeof str === "undefined") return undefined;
    return JSON.parse(str);
  } catch (e) {
    return undefined;
  }
}

export function isValidEmail(email) {
  const emailRegex = /^[\w-\.+]+@([\w-]+\.)+[\w-]{2,}$/;
  return emailRegex.test(email);
}

export function isValidPassword(password) {
  const regex =
    /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+={}[\]:"|;',.<>/?])[A-Za-z\d!@#$%^&*()_\-+={}[\]:"|;',.<>/?]{8,}$/;
  return regex.test(password);
}

export function switchSortDirection(currentDirection) {
  switch (currentDirection) {
    case constants.SORT_DIRECTIONS.ASCENDING:
      return constants.SORT_DIRECTIONS.DESCENDING;
    case constants.SORT_DIRECTIONS.DESCENDING:
    default:
      return constants.SORT_DIRECTIONS.ASCENDING;
  }
}

export function countDefinedKeys(object) {
  let count = 0;

  for (const key in object) {
    if (
      object.hasOwnProperty(key) &&
      object[key] !== undefined &&
      object[key] !== ""
    ) {
      count++;
    }
  }
  return count;
}

export function convertToLabelValueList(list) {
  if (!list || !Array.isArray(list)) return [];

  return list.map((x) => ({ label: x.name, value: x.id }));
}

export function convertToLabelValue(obj) {
  if (!obj) return;
  return { label: obj.name, value: obj.id };
}

export function convertToIdNameList(list) {
  if (!list || !Array.isArray(list)) return [];
  return list.map((x) => ({ id: x.value, name: x.label }));
}

export function convertToIdName(obj) {
  if (!obj) return;
  return { id: obj.value, name: obj.label };
}

export function equivalentObjects(objA, objB) {
  if (!objA || !objB) return false;

  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  for (const key of keysA) {
    if (objA[key] !== objB[key]) {
      return false;
    }
  }

  return true;
}

export function userHasRole(currentUser, roleIdParam){
  if(!currentUser || !currentUser.roles?.length) return false;
  if(Array.isArray(roleIdParam)){
    return currentUser.roles?.some(role => roleIdParam.includes(role?.typeOfRole));
  }
  return currentUser.roles?.some(role => role?.typeOfRole === roleIdParam);
}

export function resolveDurationCount(typeOfDuration, durationCount) {
  if(typeOfDuration && durationCount && typeof durationCount === "number") {
    const durationType = constants.DURATION_TYPES.find(d => d.value === typeOfDuration);
    //deciding if duration lable should be plural based on durationCount value
    const durationLabel = durationCount > 1 ? durationType?.label :  durationType?.label.slice(0, -1);
    if(durationType) return `${durationCount} ${durationLabel}`;
  }  
  return "";
}

export function resolveOwnedProductDurationCount(typeOfDuration, durationCount) {
  if(typeOfDuration && durationCount && typeof durationCount === "number") {
    //deciding if duration lable should be plural based on durationCount value
    const durationLabel = durationCount > 1 ? typeOfDuration :  typeOfDuration?.slice(0, -1);
    if(durationLabel) return `${durationCount} ${durationLabel}`;
  }  
  return "";
}

export function formatCurrency(dollars, isPennies) {
  if (isPennies) dollars = dollars / 100;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(dollars);
}

export function resolveSystemTenantId(currentUser, systemTenant) {
  let isSysAdmin = userHasRole(currentUser, constants.ROLE_IDS.SYS_ADMIN);
  return isSysAdmin ? "" : systemTenant?.id || "";
}

export function isSystemAdmin(currentUser) {
  return userHasRole(currentUser, constants.ROLE_IDS.SYS_ADMIN);
}

export function isDev() {
  let domainName = window.location.hostname;
  return domainName.includes(constants.DEV_DOMAIN);
  // return false; // for testing production
}

export const triggerDownloadFromBlob = (blob, filename) => {
  const downloadUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = downloadUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  URL.revokeObjectURL(downloadUrl);
};

function getFileNameExtension(fileName) {
  return fileName.substr(fileName.lastIndexOf("."));
}

export function verifyFileTypeForUpload(
    accepts,
    fileName,
    verifiedCallback,
    unverifiedCallback
  ) {
  if (!accepts) return false;
  const acceptsList = accepts.split(",");
  const extension = getFileNameExtension(fileName);
  const valid = extension && acceptsList.includes(extension);
  if (valid) {
    if (verifiedCallback) {
      verifiedCallback();
    }
  } else if (unverifiedCallback) {
    unverifiedCallback();
  }
}

export function tryParseValidationErrorMessage(err) {
  let content = err.data || err;
  if (content.isValidationError && typeof content.message === "string")
    return content.message;
  if (content.IsValidationError && typeof content.Message === "string")
    return content.Message;
  return undefined;
}

export function isInvalidID(id) {
  return id === "0"
    || id === null
    || id === undefined
    || (typeof id !== "string" && typeof id !== "number")
    || (typeof id === "string" && !!!Number.parseInt(id, 10))
    || (typeof id === "number" && !Number.isInteger(id));
}

export function romanize(num) {
  if (isNaN(num)) return NaN;
  const digits = String(+num).split("");
  const key = [
    "",
    "C",
    "CC",
    "CCC",
    "CD",
    "D",
    "DC",
    "DCC",
    "DCCC",
    "CM",
    "",
    "X",
    "XX",
    "XXX",
    "XL",
    "L",
    "LX",
    "LXX",
    "LXXX",
    "XC",
    "",
    "I",
    "II",
    "III",
    "IV",
    "V",
    "VI",
    "VII",
    "VIII",
    "IX",
  ];
  let roman = "";
  let i = 3;
  while (i--) roman = (key[+digits.pop() + i * 10] || "") + roman;
  return Array(+digits.join("") + 1).join("M") + roman;
}